import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserDiagnosisGame from 'src/games/DiagnosisGame/Main';

interface DiagnosisGameProps extends PageProps<{}> {
    onComplete?: () => void;

}

class PlatformerGame extends React.Component<DiagnosisGameProps> {
    constructor(props: DiagnosisGameProps) {
        super(props);
        bindAllOfThis(this, PlatformerGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserDiagnosisGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default PlatformerGame;



// WEBPACK FOOTER //
// ./src/pages/game/DiagnosisGame.tsx